var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    selector: null,
    menu: null,

    props: {
        target: String,
        selector: String,
    },

    data: {},

    connect() {
    },

    events: [{
        name: 'click',
        handler(ev) {
            debugger;
        }
    }],

    methods: {
    },

}
